import dayjs from "utils/dayjs";
import utc from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";
import localizedFormat from "dayjs/plugin/localizedFormat";
import useCommon from "./useCommon";

const useHotelDateTime = () => {
  const { STORE } = useCommon();

  const hotels = STORE((state) => state.ui.hotels);
  const hotelIds = STORE((state) => state.ui.hotelIds);

  // Selected hotel
  const selectedHotel = hotels?.find((h) => h._id === hotelIds?.[0]);

  // Hotel timezone
  const timezone = selectedHotel?.timezone || "UTC";

  //  Format full date + time

  const formatDateTime = (date, format = "MMM D, YYYY h:mm A") => {
    if (!date) return "-";

    try {
      return dayjs.utc(date).tz(timezone).format(format);
    } catch (err) {
      console.error("Timezone formatting error:", err);
      return "-";
    }
  };

  //    Format date only

  const formatDate = (date, format = "MMM D") => {
    if (!date) return "-";

    try {
      return dayjs.utc(date).tz(timezone).format(format);
    } catch (err) {
      console.error("Timezone formatting error:", err);
      return "-";
    }
  };

  //   Format time only

  const formatTime = (date, format = "h:mm A") => {
    if (!date) return "-";

    try {
      return dayjs.utc(date).tz(timezone).format(format);
    } catch (err) {
      console.error("Timezone formatting error:", err);
      return "-";
    }
  };

  //  Get raw dayjs object in hotel timezone

  const getHotelDateTime = (date) => {
    if (!date) return null;

    try {
      return dayjs.utc(date).tz(timezone);
    } catch (err) {
      console.error("Timezone conversion error:", err);
      return null;
    }
  };

  //    Current time in hotel's timezone

  const getHotelNow = () => {
    try {
      return dayjs().tz(timezone);
    } catch (err) {
      console.error("Timezone now error:", err);
      return dayjs();
    }
  };

  return {
    timezone,

    formatDateTime,
    formatDate,
    formatTime,

    getHotelDateTime,
    getHotelNow,
  };
};

export default useHotelDateTime;
